<template>
  <div>
    <md-dialog :md-active.sync="openDialog">
      <div class="md-layout md-gutter-sm md-alignment-center-left">
        <!-- <div
          class="md-layout-item md-size-10 md-small-size-15 md-medium-size-15 md-large-size-15"
        >
          <img class="avatar" :src="taskAvatar" alt="avatar task" />
        </div> -->
        <div class="md-layout-item md-size-80 gallery-title">
          <span>
            {{ $t(item.title) }}
            <span class="counting-images">{{
              attachments.length + ' images'
            }}</span>
          </span>
        </div>
        <div class="md-layout-item md-layout-item--no-grow md-size-20">
          <md-button
            class="md-simple md-just-icon btn-close"
            @click="toggleDialog"
          >
            <md-icon>close</md-icon>
          </md-button>
        </div>
      </div>
      <!-- <div class="md-layout md-gutter-sm md-alignment-center-left">
        <div
          class="md-layout-item md-size-10 md-small-size-15 md-medium-size-15 md-large-size-15 gallery-sort"
          @click="sortGallery()"
        >
          <md-icon>sort</md-icon>
        </div>
        <div
          class="md-layout-item md-size-90 md-small-size-85 md-medium-size-85 md-large-size-85 md-bold"
        >
          <small v-if="sort">Newest</small>
          <small v-else>Oldest</small>
        </div>
      </div> -->

      <div
        class="grid-container"
        :style="attachments.length <= 2 ? 'display: flex' : 'display: grid'"
      >
        <div v-for="(attachment, index) in attachments" :key="index">
          <img
            :src="mixinGetFilePath(attachment.src, 'M')"
            @click="openLightBoxGallery(index)"
          />
        </div>
      </div>
    </md-dialog>

    <light-box
      v-if="media && media.length"
      ref="lightbox"
      :media="media"
      :show-light-box="false"
      :show-caption="true"
      :show-thumbs="false"
      :site-loading="siteLoading"
      :disable-zoom="false"
    ></light-box>
  </div>
</template>

<script>
import LightBox from 'vue-image-lightbox';
require('vue-image-lightbox/dist/vue-image-lightbox.min.css');

export default {
  components: {
    LightBox,
  },
  data() {
    return {
      openDialog: false,
      siteLoading: require('../../../public/img/spinner.gif'),
      sort: true,
      // fakeData: [
      //   {
      //     src:
      //       'https://storage.googleapis.com/rfider-dev-file-uploads/local-environment/upload/upload-1ku3bnysx.jpeg',
      //     taskName: 'COVID-19 Declaration',
      //     date: '2021-10-28T04:46:30.788+00:00',
      //     location: 'Auckland',
      //   },
      //   {
      //     src: 'local-environment/portal/org_4/Beverage-copy-1dkse76vd3.png',
      //     taskName: 'COVID-19 Declaration',
      //     date: '2021-09-28T04:46:30.788+00:00',
      //     location: 'Auckland',
      //   },
      // ],
    };
  },
  props: {
    openModal: {
      type: Boolean,
    },
    item: Object,
    taskImgPromise: { type: Function },
  },
  watch: {
    openModal() {
      if (this.openModal && !this.openDialog) {
        this.openDialog = true;
      } else if (!this.openModal && this.openDialog) {
        this.openDialog = false;
      }
    },
  },
  asyncComputed: {
    async taskAvatar() {
      let img = null;
      const taskId = this.item ? this.item.taskId : null;
      if (taskId && this.taskImgPromise) {
        img = await this.taskImgPromise(taskId);
      }
      return img
        ? this.mixinGetFilePath(img, 'O')
        : '/img/avatars/avatar-task-default.png';
    },
  },
  computed: {
    attachments() {
      let result = [];
      const location = this.extractInteractionLocation(this.item);

      // Extracting interaction images
      result = result.concat(
        this.extractAttachmentsImages(this.item, this.item.taskName, location),
      );

      // Extracting interaction steps's images
      if (this.item.steps) {
        this.item.steps.map((step) => {
          result = result.concat(
            this.extractAttachmentsImages(step, this.item.taskName, location),
          );
        });
      }

      // result = result.concat(this.fakeData);
      return result;
    },
    media() {
      let media = [];
      media = this.attachments.map((attachment) => {
        return {
          src: this.mixinGetFilePath(attachment.src, 'O'),
          caption: `<html> <p>${attachment.taskName}</p> <span>${
            attachment.location
          }<br />${this.displayTimeZone(
            attachment.date,
            'DD/MM/YYYY [at] h:mm A',
          )}</span>`,
        };
      });
      return media;
    },
  },
  methods: {
    toggleDialog() {
      this.$emit('toggle-dialog');
    },
    sortGallery() {
      if (this.sort) {
        this.attachments.sort((a, b) => new Date(a.date) - new Date(b.date));
      } else {
        this.attachments.sort((a, b) => new Date(b.date) - new Date(a.date));
      }
      this.sort = !this.sort;
    },
    extractAttachmentsImages(object, taskName, location) {
      let images = [];
      const captionDate = object._id ? object.createdAt : object.startedAt;
      if (object.metadata && Array.isArray(object.metadata.attachments)) {
        object.metadata.attachments.forEach((attachment) => {
          if (this.mixinGetImageRegex().test(attachment.file)) {
            images.push({
              src: attachment.file,
              taskName: taskName,
              date: captionDate,
              location: location,
            });
          }
        });
      }
      return images;
    },
    extractInteractionLocation(interaction) {
      let finalLocation = 'Unknown Location';

      try {
        const { components } = interaction.metadata.location.details || {};
        const location = !components
          ? []
          : components
              .filter((element) => {
                return element.types.includes('political');
              })
              .slice(-2);

        if (location.length > 0) {
          let city = location[0] ? location[0].long_name : null;
          let country = location[1] ? location[1].long_name : null;
          if (city) {
            finalLocation = city;
            if (country) {
              finalLocation = `${city}, ${country}`;
            }
          }
        }
      } catch (e) {
        console.log(e);
        finalLocation = 'Unknown Location';
      }

      return finalLocation;
    },
    openLightBoxGallery(index) {
      this.$refs.lightbox.showImage(index);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/public/_public-interactions-event-gallery.scss';
</style>
